<template>
  <div>
    <div>
      <NavBar />
      <v-container>
        <MainMenu />
        <v-row>
          <v-col cols="12">
            <notification-container class="mr-5 ml-5"></notification-container>
          </v-col>
        </v-row>

        <account></account>
      </v-container>
    </div>
  </div>
</template>

<script>
import Account from '@/modules/users/components/Account'
export default {
  name: 'AccountPage',
  components: {
    Account
  }
}
</script>
